import { addDays, isBefore, isValid, startOfToday } from 'date-fns';

export const SECONDS_IN_DAY = 86400;
export const SECONDS_IN_24_HOURS = 60 * 60 * 24;

//4h  60*60*4
export const SECONDS_IN_MINUTES = 60;
//4h  60*60*4
export const SECONDS_IN_4_HOURS = 14400;
//1h 60*60
export const SECONDS_IN_1_HOURS = 3600;
//15m 60*15
export const SECONDS_IN_15_MINS = 900;
//5m  60*5
export const SECONDS_IN_5_MINS = 300;

// https://date-fns.org/v4.1.0/docs/format#
// Format: Sep 12
export const FORMAT_MMM_D = 'MMM d';
// Format: Sep 12, 2025
export const FORMAT_MMM_D_YYYY = 'MMM d, yyyy';
// Format: Fri 09/12/2025
export const FORMAT_CCC_P = 'ccc P';
// Format: Friday, September 12th, 2025 - 1:57PM
export const FORMAT_FULL_DATE_TIME = "EEEE, MMMM do, yyyy - h:mma";
// Format: Sep 12, 2025, 1:57:19 PM GMT-5
export const FORMAT_PPP = 'PPp z';
// Format: 2025-09-12
export const SHORT_DATE_FORMAT = 'yyyy-MM-dd';
// Format: 1:57 PM
export const SHORT_TIME_FORMAT = 'h:mm aaa';
// Format: Sep 12, 2025, 1:58 PM
export const FULL_DATE_TIME = 'MMM d, yyyy, h:mm a';
export const FULL_MONTH_DATE_TIME = 'MMMM d, yyyy, h:mm a';

export const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
// @deprecated use `USER_TIMEZONE`
export const getUsersTimezone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const convertEpochUTCSecondsToDate = (seconds = 0): Date => {
  const date = new Date(0);
  date.setUTCSeconds(seconds);
  return date;
};

// returns date as seconds since Jan 1, 1970
export const getCurrentUnixTimestamp = () => Math.round((new Date()).getTime() / 1000);

export const isBeforeToday = (date: Date): boolean => {
  if (!date || !isValid(date)) return false;
  return isBefore(date, startOfToday());
};

export const get42DayMonthOffsets = (date: Date): Date[] => {
  if (!date || !isValid(date)) return [];

  const year = date.getFullYear();
  const month = date.getMonth();

  // get start and end dates of the month
  const monthStart = new Date(year, month, 1);

  // calculate the date offset needed to start on the beginning of a week
  const startDateOffset = monthStart.getDate() - monthStart.getDay();

  const startDate = new Date(year, month, startDateOffset);

  // the calendar displays 42 days
  const endDate = addDays(startDate, 42);

  return [startDate, endDate];
};

export const getMonthName = (monthNumber: number) => {
  const date = new Date();
  // Reset to first day of the month or else "setMonth" will go to following month if
  // current day is 31st
  date.setDate(1);
  date.setMonth(monthNumber - 1);
  return date.toLocaleString('en-US', { month: 'long' });
};
